export const softwareApplicationSchema = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "name": "Raskh",
  "alternateName": "رسخ",
  "operatingSystem": "Web",
  "applicationCategory": "EducationalApplication",
  "inLanguage": ["en", "ar"],
  "offers": [
    { "@type": "Offer", "price": "0", "priceCurrency": "SAR", "name": "Free", "description": "Try Raskh's interactive demo without signing up: drop a PDF and generate sample flashcards, a mind map, and a podcast." },
    { "@type": "Offer", "price": "49", "priceCurrency": "SAR", "name": "Plus", "description": "Unlimited flashcards, unlimited question generation, unlimited voice teach-back, unlimited oral practice, and Concept Mastery tracking." },
    { "@type": "Offer", "price": "89", "priceCurrency": "SAR", "name": "Pro", "description": "Everything in Plus, plus Document Insights, Mind Map generation, grade prediction, decay visualization, and priority processing." }
  ],
  "featureList": [
    "AI flashcard generation from uploaded PDFs",
    "Mind map generation from documents",
    "AI-generated podcasts from study material",
    "Oral evaluation and speak testing",
    "Feynman Technique voice teach-back mode",
    "Concept mastery tracking with decay visualization",
    "Spaced repetition review scheduling",
    "Document chat and question answering",
    "AI-generated practice questions",
    "Video explainer generation",
    "No streaks and no daily-pressure mechanics (by design)",
    "Bilingual Arabic and English support including Arabic OCR"
  ]
};
